import script from "./supervise.vue?vue&type=script&setup=true&lang=js"
export * from "./supervise.vue?vue&type=script&setup=true&lang=js"

import "./supervise.vue?vue&type=style&index=0&id=cd71c9c6&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd71c9c6"]])

export default __exports__